import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreOptionsInPreview: {
		id: 'polaris-lib-field-option-configuration.option-list.more-options-in-preview',
		defaultMessage: '+ {number, plural, one {1 more option} other {{number} more options}}',
		description: 'The number of options that are not visible in the preview list',
	},
});
